// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const header = document.getElementById('header');
const burgerMenu = document.getElementById('burger-menu');
const bookingBtn = document.querySelector(".bookingCMS");

(function(){

	window.onload = function() {
	    if (document.getElementsByClassName('no-hero').length < 1) {
			scrollW();
		} else {
			header.classList.add('scroll');
			changeSrc(document.querySelector('.js-scroll-logo').getElementsByTagName('img')[0]);
		}
	
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};

	/* Main Nav */
	document.getElementById('js-menu-trigger').addEventListener('click', (e) =>{
		e.preventDefault();
		document.body.classList.toggle('no-scroll');
		burgerMenu.classList.add('open');
	});

	document.getElementById('js-menu-close').addEventListener('click', () =>{
		document.body.classList.remove('no-scroll');
		burgerMenu.classList.remove('open');
	});
	
    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	});


	/* Home Booking Flatpickr */
	if(document.getElementById('home-booking')){
		const bookingDates = flatpickr("#booking-dates", {
			dateFormat: "m/d/Y",
			minDate: 'today',
			mode: 'range',
			onChange: function(selectedDates, dateStr, instance) {
				if (selectedDates.length === 2) {
					const dates = dateStr.split(" ");
					instance.element.value = dateStr.replace('to', '-');

					document.getElementById("home-checkin").value = dates[0];
					document.getElementById("home-checkout").value = dates[2];
				};
			}
		});
	};

	/* CMS forms label animation */
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	};


	/* LIGHTBOX */
	if (document.getElementsByClassName('lightbox').length > 0) {
		let allLightboxes = document.getElementsByClassName('js-lbxbtn');
		let allLightboxesLength = allLightboxes.length;

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		let allLbxWraps = document.querySelectorAll('.lightbox');
	
		for (let j = 0; j < allLightboxesLength; j++) {
			allLightboxes[j].addEventListener('click', function (e) {
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});
		}
	
		for (let j = 0; j < allLightclosesLength; j++) {
			allLightcloses[j].addEventListener('click', function (e) {
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}
	
		for (const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap');
				if (!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			});
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(bookingBtn) {
		setTimeout(updateClass, 850);
	}

	document.addEventListener('DOMContentLoaded', (event) => {
                
		let weatherBox = document.querySelector('#weatherContainer');
		if (weatherBox){
			const WEATHER_API_CONF = {
				target: "#weatherContainer",
				api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
				zip: sym_zip+",fl",
				lat: latitude,
				lon: longitude,
				units: "metric",
				getters: {
					// Coordinates by zip/post code
					coordinates: `https://api.openweathermap.org/geo/1.0/zip?zip=`+sym_zip+`,fl&appid=0ddd1af8b5b1833cedd6da7a90934cce`,
					// Call current weather data
					current_weather: `https://api.openweathermap.org/data/2.5/weather?lat=`+latitude+`&lon=`+longitude+`&appid=0ddd1af8b5b1833cedd6da7a90934cce`,
				},
				url_icon: "https://openweathermap.org/img/wn/",
			};

			const weatherApi = () => {
				let urlApi = `${WEATHER_API_CONF.getters.current_weather}&units=${WEATHER_API_CONF.units}`;
				urlApi = urlApi.replace("{lat}", WEATHER_API_CONF.lat);
				urlApi = urlApi.replace("{lon}", WEATHER_API_CONF.lon);
				urlApi = urlApi.replace("{api_key}", WEATHER_API_CONF.api_key);

				fetch(urlApi).then((response) => response.json()).then((data) => {
						let weatherIcon = data.weather[0].icon;
						let weatherTemp = data.main.temp;
						let weatherDesc = data.weather[0].description;
						let degrees = weatherTemp.toFixed(1);
						// let iconExists = false; 
						// document.querySelectorAll('.js-weather-icon').forEach(icon => {
						// 	if(icon.dataset.icon == weatherIcon){
						// 		icon.classList.remove('hidden');
						// 		iconExists = true;
						// 	} else {
						// 		icon.classList.add('hidden');
						// 	}
						// });

						// if(iconExists === false){
						// 	document.querySelector('[data-icon="03d"]').classList.remove('hidden');
						// }

						let celsius_without_decimals = Math.ceil(degrees),fahrenheit_without_decimals = Math.ceil(( (degrees *1.8) + 32));
						let weatherHTML = `${fahrenheit_without_decimals} °F`;
						weatherBox.innerHTML = weatherHTML;
					});

			};
			weatherApi();
		}
	});

})();

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!header.classList.contains('scroll')){
			header.classList.add('scroll');
			changeSrc(document.querySelector('.js-scroll-logo').getElementsByTagName('img')[0]);
		};
	} else {
		if (document.getElementsByClassName('no-hero').length < 1) {
			if (header.classList.contains('scroll')) {
				header.classList.remove('scroll');
				changeSrc(document.querySelector('.js-scroll-logo').getElementsByTagName('img')[0]);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function updateClass() {
	const close = document.querySelector(".close-icon");

	bookingBtn.addEventListener("click", () => {
		document.body.classList.add("no-scroll", "booking-open")
	})
	close.addEventListener("click", () => {
		document.body.classList.remove("no-scroll", "booking-open")
	})
	
}

//Mobile Submenu Funcionality
document.querySelectorAll('.navigation > .inner > ul > li > a').forEach(link => {
	link.addEventListener('click', e => {
		if (link.nextSibling.nextSibling != null) {
			document.querySelectorAll('.inner > ul > li').forEach(item => {
				if (link.parentNode !== item) item.classList.remove('submenu-show');
			});
			e.preventDefault();
			link.parentNode.classList.toggle('submenu-show')
		}
	});
});

//add class for icon dropdown 
document.querySelectorAll('.navigation > .inner > ul > li > .sub-sub-menu').forEach(link => {
	let menu = link.parentNode.firstElementChild;
	menu.classList.add('icon-dropdown');
})

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#burger-menu');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
	
	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#burger-menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});